import * as echarts from "echarts";
import chinaMap from "@/utils/map.json";
var chinaGeoCoordMap = {
  黑龙江: [127.9688, 45.368],
  内蒙古: [110.3467, 41.4899],
  吉林: [125.8154, 44.2584],
  北京市: [116.4551, 40.2539],
  辽宁: [123.1238, 42.1216],
  河北: [114.4995, 38.1006],
  天津: [117.4219, 39.4189],
  山西: [112.3352, 37.9413],
  陕西: [109.1162, 34.2004],
  甘肃: [103.5901, 36.3043],
  宁夏: [106.3586, 38.1775],
  青海: [101.4038, 36.8207],
  新疆: [87.9236, 43.5883],
  西藏: [91.11, 29.97],
  四川: [103.9526, 30.7617],
  重庆: [108.384366, 30.439702],
  山东: [117.1582, 36.8701],
  河南: [113.4668, 34.6234],
  江苏: [118.8062, 31.9208],
  安徽: [117.29, 32.0581],
  湖北: [114.3896, 30.6628],
  浙江: [119.5313, 29.8773],
  福建: [119.4543, 25.9222],
  江西: [116.0046, 28.6633],
  湖南: [113.0823, 28.2568],
  贵州: [106.6992, 26.7682],
  云南: [102.9199, 25.4663],
  Guangdong: [113.12244, 23.009505],
  广西: [108.479, 23.1152],
  海南: [110.3893, 19.8516],
  上海: [121.4648, 31.2891],
};
export default {
  // 新增
  chinaCharts() {
    let option = {
      backgroundColor: "rgba(0, 10, 52, 1)",
      tooltip: {
        trigger: "item",
        backgroundColor: "#04284e",
        borderColor: "#04284e",
        showDelay: 0,
        hideDelay: 0,
        enterable: true,
        transitionDuration: 0,
        extraCssText: "z-index:100",
        formatter: function (params, ticket, callback) {
          //根据业务自己拓展要显示的内容
          var res = "";
          var name = params.name;
          var value = 11;
          res =
            "<span style='color:#fff;'>" + name + "</span><br/>数据：" + value;
          if (1) {
            return res;
          } else {
            return "";
          }
        },
      },
      // tooltip: {
      //   show: true,
      //   enterable: true, //鼠标可进入浮层内
      //   // triggerOn: "click", // 点击触发
      //   backgroundColor: "white",
      //   padding: 10,
      //   extraCssText:
      //     "box-shadow: 0 0 3px rgba(255, 255, 255, 0.9);border-radius: 8px;opacity: 0.8;border: 2px solid #fff;width: 200px;height: 148px;",
      //   textStyle: {
      //     color: "#fff",
      //   },
      //   formatter: function (params) {
      //     return `
      //     <ul class="map-tooltip">
      //       <li class="title">
      //         <p class="circle"></p>
      //         <p class="province">省份</p>
      //         <p class="province-name">222</p>
      //       </li>
      //       <li>
      //         <p class="name">科研费:</p>
      //         <p class="color" style="color:#048AFC">1111
      //             </p>
      //       </li>

      //     </ul>
      //   `;
      //   },
      // },
      // 地理坐标系组件
      geo: {
        show: true,
        map: "china",
        roam: false, // 是否开启鼠标缩放移动和平移漫游
        aspectScale: 1, //参数用于 scale 地图的长宽比。
        layoutCenter: ["50%", "51.5%"], //地图位置
        layoutSize: "116%", //地图的大小
        // label: {
        //   show: true,
        //   color: "#fff",
        //   fontSize: 10,
        // },
        label: {
          normal: {
            show: true,
            fontSize: "10",
            color: "rgba(255,255,255,0.9)",
          },
          emphasis: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        select: {
          itemStyle: {
            color: "#389bb7",
            areaColor: "#389bb7",
          },
        },
        itemStyle: {
          normal: {
            borderColor: "rgba(147, 235, 248, 1)",
            borderWidth: 1,
            areaColor: {
              type: "radial",
              x: 0.5,
              y: 0.5,
              r: 0.8,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(147, 235, 248, 0)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(147, 235, 248, .2)", // 100% 处的颜色
                },
              ],
              globalCoord: false, // 缺省为 false
            },
            shadowColor: "rgba(128, 217, 248, 1)",
            // shadowColor: 'rgba(255, 255, 255, 1)',
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10,
          },
          // emphasis: {
          //   show: true,
          //   areaColor: "#3066ba", //鼠标滑过区域颜色
          //   show: true,
          //   textStyle: {
          //     color: "#fff", //鼠标经过字体颜色
          //   },
          // },
          emphasis: {
            areaColor: "#389BB7",
            borderWidth: 0,
            color: "#fff",
            label: {
              show: true,
              textStyle: {
                color: "#fff", //鼠标经过字体颜色
              },
            },
          },
        },
      },

      series: [
        {
          type: "map",
          map: "china",
          aspectScale: 1,
          geoIndex: 0,
          selectedMode: false,
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#031525",
              borderColor: "#FFFFFF",
            },
            emphasis: {
              areaColor: "#2B91B7",
            },
            // emphasis: {
            //   show: true,
            //   areaColor: "#3066ba", //鼠标滑过区域颜色
            //   label: {
            //     show: true,
            //     textStyle: {
            //       color: "#fff", //鼠标经过字体颜色
            //     },
            //   },
            // },
          },
          data: [1111, 222, 2, 2323, 2, 323, 23, 12, 41, 24, 12, 41, 24, 3],
          nameMap: "en",
          nameProperty: "name",
          animation: false,
        },
        {
          type: "effectScatter",
          coordinateSystem: "geo",
          zlevel: 2,
          rippleEffect: {
            //涟漪特效
            period: 5, //动画时间，值越小速度越快
            brushType: "stroke", //波纹绘制方式 stroke, fill
            scale: 4, //波纹圆环最大限制，值越大波纹越大
          },
          label: {
            normal: {
              show: true,
              position: "right", //显示位置
              offset: [5, 0], //偏移设置
              formatter: (params) => {
                //圆环显示文字
                return "";
              },
              fontSize: 11,
            },
            emphasis: {
              show: true,
            },
          },
          symbol: "circle",
          symbolSize: function (val) {
            return 5 + val[2] * 5; //圆环大小
          },
          itemStyle: {
            normal: {
              show: true,
              color: "#00eaff",
            },
          },
          data: chinaMap["features"].map((dataItem) => {
            let item = dataItem.properties;
            console.log(777, item);
            let center = item.center?.concat("0");
            return {
              name: "",
              // value: "",
              value: center ? center : [],
            };
            //  {
            //   name: dataItem[0].name,
            //   value: chinaGeoCoordMap[dataItem[0].name].concat([
            //     dataItem[0].value,
            //   ]),
            //   // visualMap: false
            // };
          }),
        },
      ],
    };

    return option;
  },
  // #region 数据大屏图表配置数据-------------------------------------------------------------------------------------------------------------------------------------------
  // 近7日工况信息表
  Schart1(value, isTrue = false) {
    // 声明图表x,Y轴初始变量
    let dataX = [];
    let dataY1 = [];
    let dataY = [];
    // 对数据进行遍历，提取日期数据并转换格式
    if (value === null) {
      dataX = dataY1 = dataY = [0, 0, 0, 0, 0, 0, 0];
    } else {
      value.forEach((item) => {
        // 近七日耗油量
        dataY1.push(item.oilCost);
        // 近七日工作时间
        dataY.push(item.workTime);
        if (item.dataDate.slice(4, 8)[0] == 0) {
          // 截取拼接字符
          dataX.push(
            item.dataDate.slice(5, 6) + "/" + item.dataDate.slice(6, 8)
          );
        } else {
          dataX.push(
            item.dataDate.slice(4, 6) + "月" + item.dataDate.slice(6, 8)
          );
        }
      });
    }
    let option = {
      // backgroundColor: "#0D2753",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none",
        },
        formatter: function (params) {
          return (
            dataX[params[0].dataIndex] +
            "<br/>" +
            (isTrue ? "working hours：" : "工作时长：") +
            dataY[params[0].dataIndex] +
            " h" +
            "<br>" +
            (isTrue ? "fuel efficiency：" : "油耗：") +
            dataY1[params[0].dataIndex] +
            " L"
          );
        },
      },
      grid: {
        top: "12%",
        bottom: "2%",
        left: "5%",
        right: "5%",
        containLabel: true,
      },
      legend: {
        show: true,
        data: [
          isTrue ? "fuel efficiency(L)" : "油耗(L)",
          isTrue ? "working hours(h)" : "工作时长(h)",
        ],
        left: "center",
        top: "0",
        textStyle: {
          padding: [4, 0, 0, 0],
          color: "#33FFFF",
        },
        itemWidth: 15,
        itemHeight: 10,
        itemGap: 25,
      },
      xAxis: {
        type: "category",
        data: dataX,
        axisLine: {
          lineStyle: {
            color: "rgba(66, 192, 255, .3)",
          },
        },

        axisLabel: {
          rotate: -45,
          color: "#33FFFF",
        },
      },

      yAxis: [
        {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#5FBBEB",
          },
          axisLine: {
            lineStyle: {
              fontSize: 12,
              color: "rgba(66, 192, 255, .3)",
            },
          },
        },
        {
          type: "value",
          name: "",
          nameTextStyle: {
            color: "#d2d2d2",
          },
          // max: "100",
          min: "0",
          scale: true,
          position: "right",
          axisLine: {
            lineStyle: {
              color: "rgba(66, 192, 255, .3)",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: "{value} ", //右侧Y轴文字显示
            fontSize: 12,
            color: "#42C0FF",
          },
        },
      ],
      series: [
        {
          name: isTrue ? "fuel efficiency(L)" : "油耗(L)",
          type: "bar",
          barWidth: "12px",
          itemStyle: {
            color: "rgba(36,144,206,.2)",
            borderColor: "#267ea9",
          },
          data: dataY1,
        },
        {
          name: isTrue ? "working hours(h)" : "工作时长(h)",
          type: "line",
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          smooth: false, //平滑曲线显示

          symbol: "circle", //标记的图形为实心圆
          symbolSize: 8, //标记的大小
          itemStyle: {
            color: "rgb(117, 249, 185)",
            borderColor: "rgba(117, 249, 185,0.8)", //圆点透明 边框
            borderWidth: "1px",
          },
          lineStyle: {
            color: "rgba(117, 249, 185,0.5)",
          },

          data: dataY,
        },
      ],
    };
    return option;
  },
  // 页面四个圆形图表的配置数据
  Schart2(value, isTrue = false) {
    /* const obj = {
      name: "Bobo",
      job: " Master",
      number: 1234,
    };
    const renameKeys = (keysMap, obj) => {
      console.log('Object.keys(obj)',Object.keys(obj))
      let asd = Object.keys(obj).reduce((acc, key) => {
        // console.log('12333',{[keysMap[key] || key]: obj[key]});
        // return acc
        // console.log("keysMap", keysMap);
        // console.log("obj", obj);
        console.log("acc", acc);
        console.log("key", key);
      });
      console.log('asd',asd)
    };
    console.log(
      "====================",
      renameKeys(
        {
          name: " firstName",
          number: " id",
        },
        obj
      )
    ); */
    //{ job: 'Master', id: 1234, Las tName: ' Bobo ' }

    let arr = [],
      total = 0;
    value.forEach((item) => {
      total += Number(item.amount);
      let obj = {
        value: Number(item.amount),
        name: isTrue ? item.typeLabelEng : item.typeLabel,
        name2: item.typeLabelEng,
      };
      arr.push(obj);
    });
    let option = {
      /* tooltip: {
        trigger: "item",
      },*/
      tooltip: {
        position: "right",
        formatter: function (params) {
          return (
            "<div><p>" +
            (isTrue ? params.data.name2 : params.data.name) +
            "：" +
            params.data.value +
            "</p></div>"
          );
        },
      },
      title: {
        text: isTrue ? "TDC" : "设备总数",
        textStyle: {
          fontSize: 10,
          color: "#78898f",
        },
        left: "center",
        top: "58%",
      },
      series: [
        {
          name: "设备类型",
          type: "pie",
          radius: ["70%", "80%"],
          avoidLabelOverlap: false,
          // color: "#75d059",
          label: {
            color: "#05afe0",
            formatter: `${total}`,
            show: true,
            fontSize: "16",
            fontWeight: "bold",
            position: "center",
          },
          data: arr,
        },
      ],
    };
    return option;
  },
  Schart3(value, isTrue = false) {
    let arr = [],
      total = 0;
    value.forEach((item) => {
      total += Number(item.num);
      let obj = {
        value: Number(item.num),
        name: item.levelLabel,
      };
      arr.push(obj);
    });
    let option = {
      /*tooltip: {
        trigger: "item",
      },*/
      tooltip: {
        position: "right",
        formatter: function (params) {
          return (
            "<div><p>" +
            params.data.name +
            "：" +
            params.data.value +
            "</p></div>"
          );
        },
      },
      title: {
        text: isTrue ? "TRC" : "风险总数",
        textStyle: {
          fontSize: 10,
          color: "#78898f",
        },
        left: "center",
        top: "58%",
      },
      series: [
        {
          color: ["#dd0000", "#ff8a00", "#ebce41"],
          name: "风险事件",
          type: "pie",
          radius: ["70%", "80%"],
          label: {
            color: "#05afe0",
            formatter: "{c}",
            show: true,
            fontSize: "14",
            fontWeight: "bold",
            position: "center",
          },
          data: arr,
        },
      ],
    };
    return option;
  },
  Schart4(value, isTrue = false) {
    let option = {
      tooltip: {
        trigger: "item",
      },
      title: {
        // TTC
        text: isTrue ? "TTC" : "运输总数",
        textStyle: {
          fontSize: 10,
          color: "#78898f",
        },
        left: "center",
        top: "58%",
      },
      series: [
        {
          name: isTrue ? "Crawler Crane" : "履带吊",
          type: "pie",
          radius: ["70%", "80%"],
          avoidLabelOverlap: false,
          color: "#2144c9",
          label: {
            color: "#05afe0",
            formatter: "{c}",
            show: true,
            fontSize: "15",
            fontWeight: "bold",
            position: "center",
          },
          data: [
            {
              value,
              name: isTrue
                ? "Annual Transportation Kilometers"
                : "年运输公里数",
            },
          ],
        },
      ],
    };
    return option;
  },
  // #endregion
  // #region 设备详情图表配置数据-------------------------------------------------------------------------------------------------------------------------------------------
  // 近7日工况信息表
  // 模块二工作时长图表
  Dchart1(value) {
    // 声明图表x,Y轴初始变量
    let dataX = [];
    let dataY1 = [];
    let dataY = [];
    // 对数据进行遍历，提取日期数据并转换格式
    value.forEach((item) => {
      // 近七日耗油量
      dataY1.push(item.oilCost);
      // 近七日工作时间
      dataY.push(item.workTime);
      if (item.dataDate.slice(4, 8)[0] == 0) {
        // 截取拼接字符
        dataX.push(item.dataDate.slice(5, 6) + "/" + item.dataDate.slice(6, 8));
      } else {
        dataX.push(
          item.dataDate.slice(4, 6) + "月" + item.dataDate.slice(6, 8)
        );
      }
    });
    let option = {
      // backgroundColor: "#0D2753",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none",
        },
        formatter: function (params) {
          return (
            dataX[params[0].dataIndex] +
            "<br/>工作时长：" +
            dataY[params[0].dataIndex] +
            " h" +
            "<br> 油耗：" +
            dataY1[params[0].dataIndex] +
            " L"
          );
        },
      },
      grid: {
        top: "10%",
        bottom: "0%",
        left: "5%",
        right: "5%",
        containLabel: true,
      },
      legend: {
        show: true,
        data: ["油耗", "工作时长"],
        left: "center",
        top: "0",
        textStyle: {
          padding: [4, 0, 0, 0],
          color: "33FFFF",
        },
        itemWidth: 15,
        itemHeight: 10,
        itemGap: 25,
      },
      xAxis: {
        type: "category",
        data: dataX,
        axisLine: {
          lineStyle: {
            color: "rgba(66, 192, 255, .3)",
          },
        },

        axisLabel: {
          rotate: -45,
          color: "#000",
        },
      },

      yAxis: [
        {
          type: "value",
          splitLine: {
            show: true,
          },
          axisLabel: {
            color: "#000",
          },
          axisLine: {
            lineStyle: {
              fontSize: 12,
              color: "rgba(66, 192, 255, .3)",
            },
          },
        },
        {
          type: "value",
          name: "",
          nameTextStyle: {
            color: "#d2d2d2",
          },
          // max: "100",
          min: "0",
          scale: true,
          position: "right",
          axisLine: {
            lineStyle: {
              color: "rgba(66, 192, 255, .3)",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: "{value} ", //右侧Y轴文字显示
            fontSize: 12,
            color: "#000",
          },
        },
      ],
      series: [
        {
          name: "油耗",
          type: "bar",
          barWidth: "12px",
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#205aff",
              },
              {
                offset: 1,
                color: "#4bdfff",
              },
            ]),
            borderRadius: 6,
          },
          data: dataY1,
        },
        {
          name: "工作时长",
          type: "line",
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          smooth: false, //平滑曲线显示

          symbol: "circle", //标记的图形为实心圆
          symbolSize: 8, //标记的大小
          itemStyle: {
            color: "#ffa43a",
            borderColor: "rgba(255, 234, 0, 0.5)", //圆点透明 边框
            borderWidth: 5,
          },
          lineStyle: {
            color: "#ffa43a",
          },

          data: dataY,
        },
      ],
    };
    return option;
  },
  // 模块三油量图表
  Dchart2(value) {
    // value; 图上角度数据
    let angle = 0; //角度，用来做简单的动画效果的
    let option = {
      // backgroundColor: "#061740",
      title: [
        {
          text: "{a|" + value + "}{c|%}",
          x: "center",
          y: "50%",
          textStyle: {
            rich: {
              a: {
                // fontSize: 45,
                color: "#000",
                fontWeight: "bold",
              },
              c: {
                // fontSize: 45,
                color: "#000",
                fontWeight: "normal",
              },
            },
          },
        },
      ],
      series: [
        //内环
        {
          name: "",
          type: "custom",
          coordinateSystem: "none",
          renderItem: function (params, api) {
            return {
              type: "arc",
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: (Math.min(api.getWidth(), api.getHeight()) / 2.3) * 0.65,
                startAngle: ((0 + -angle) * Math.PI) / 180,
                endAngle: ((360 + -angle) * Math.PI) / 180,
              },
              style: {
                stroke: "#0CD3DB",
                fill: "transparent",
                lineWidth: 0.5,
              },
              silent: true,
            };
          },
          data: [0],
        },
        //外环
        {
          name: "",
          type: "pie",
          radius: ["85%", "70%"],
          silent: true,
          clockwise: true,
          startAngle: 90,
          z: 0,
          zlevel: 0,
          label: {
            position: "center",
          },
          data: [
            {
              value: value,
              name: "",
              itemStyle: {
                //外环发光
                borderWidth: 0.5,
                shadowBlur: 20,
                borderColor: "#4bf3f9",
                shadowColor: "#9bfeff",
                color: {
                  // 圆环的颜色
                  colorStops: [
                    {
                      offset: 0,
                      color: "#205aff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#4bf3f9", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            {
              value: 100 - value,
              name: "",
              label: {
                show: false,
              },
              itemStyle: {
                color: "#173164",
              },
            },
          ],
        },
      ],
    };
    return option;
  },
  // #endregion
};
